module.exports = __webpack_public_path__ + "static/mesh-large-2021101a73a1c48b69f957a5e3f7e624.svg";